import { createContext, Dispatch, JSX, SetStateAction, useEffect, useState } from "react";

interface DocumentTitleContextOutgoing {
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
}

const fallbackTitle = "Quest Analytics®";
export const DocumentTitleContext = createContext<DocumentTitleContextOutgoing>({
  setTitle: () => null,
  title: fallbackTitle,
});

export const DocumentTitleContextProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [title, setTitle] = useState<string>(fallbackTitle);

  /*
    A default/fallback title is declared in _Layout.cshtml, and that's used
    before QES is downloaded and React starts up. But only one <title> tag
    is allowed, so we have to remove that one when we add our dynamic one.
  */
  useEffect(() => {
    const fallback = document.querySelector("[data-testid='fallback-title']");
    if (!!fallback) {
      fallback.parentNode.removeChild(fallback);
    }
  }, []);

  return (
    <DocumentTitleContext.Provider
      value={{
        setTitle,
        title
      }}
    >
      {children}
    </DocumentTitleContext.Provider>
  );
};
